module.exports = __webpack_public_path__ + "static/media/postman2.08e747bd.png";